import plainDayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/sv';
import 'dayjs/locale/da';
import 'dayjs/locale/de';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl';

plainDayjs.extend(isBetween);
plainDayjs.extend(isSameOrAfter);
plainDayjs.extend(utc);
plainDayjs.extend(timezone);
plainDayjs.extend(localizedFormat);

export const dayjs = plainDayjs;

export const localizedDayjs =
    (locale) =>
    (...args) =>
        dayjs(...args).locale(locale);

export const swedishTimeZoneDate = (date, localizedDayjsFn) => {
    // This is a workaround for locale being lost when using .tz() in Nextweb
    const locale = localizedDayjsFn().locale();
    return localizedDayjsFn(date).tz('Europe/Stockholm').locale(locale);
};

export const formatUtcDateAsSwedishTimeZoneDate = (date, localizedDayjsFn) =>
    swedishTimeZoneDate(date, localizedDayjsFn).format('D MMM HH:mm');

/**
 * Format a number of seconds to an object of time units
 *
 * @param {number} seconds
 * @param {object} [options]
 * @param {string} [options.startUnit] - Time part to start counting from, empty for all parts
 * @param {string} [options.endUnit] - Time part to stop counting on, empty for all parts
 * @returns {{string: integer}}
 */
export const getTimeSpanParts = (seconds, options = {}) => {
    const optionsWithDefaults = {
        startUnit: '',
        endUnit: '',
        ...options
    };
    const parts = {};
    let remaining = seconds;
    let started = !optionsWithDefaults.startUnit;
    for (const [part, length] of Object.entries(TIME_SPAN_UNIT_LENGTHS)) {
        if (!started && part === optionsWithDefaults.startUnit) started = true;
        if (started) {
            if (remaining >= length) {
                parts[part] = Math.floor(remaining / length);
            }
            // eslint-disable-next-line better-mutation/no-mutation
            remaining %= length;
            if (remaining === 0 || optionsWithDefaults.endUnit === part) break;
        }
    }
    return parts;
};

export const TIME_SPAN_UNITS = {
    DAYS: 'days',
    HOURS: 'hours',
    MINUTES: 'minutes',
    SECONDS: 'seconds'
};

const TIME_SPAN_UNIT_LENGTHS = {
    [TIME_SPAN_UNITS.DAYS]: 24 * 60 * 60,
    [TIME_SPAN_UNITS.HOURS]: 60 * 60,
    [TIME_SPAN_UNITS.MINUTES]: 60,
    [TIME_SPAN_UNITS.SECONDS]: 1
};
